module.exports = __webpack_public_path__ + "static/scale-model-of-west-jordan-off-leash-dog-park-in-west-jordan-utah-8e5d3e2abbcb9f4dab97992ba0b4bdf5.png";